import React from "react";
export const ChevronRight: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.74999 2.93923L11.0732 7.26245C11.7566 7.94587 11.7566 9.05391 11.0732 9.73732L6.74999 14.0605L5.68933 12.9999L10.0126 8.67666C10.1102 8.57903 10.1102 8.42074 10.0126 8.32311L5.68933 3.99989L6.74999 2.93923Z"
      fill="#161C22"
    />
  </svg>
);
